import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { cn } from '@/helpers/classnames';

interface CurrentUserBadgeProps {
  className?: string;
}

export const CurrentUserBadge: FC<CurrentUserBadgeProps> = ({ className }) => {
  return (
    <span
      className={cn(
        'rounded-full bg-primary-500 px-2 py-0.5 text-xs font-bold text-contrast-primary',
        className,
      )}
    >
      <FormattedMessage defaultMessage="Du" />
    </span>
  );
};
